export default {
  setSalesCount(state, data) {
    state.salesCount = data;
  },
  setSumSales(state, data) {
    state.sumSales = data;
  },
  setSalesCountInMonth(state, data) {
    state.salesCountInMonth = data;
  },

  setVisits(state, data) {
    state.visits = data;
  },

  setMostVisited(state, data) {
    state.mostVisited = data;
  },

  setMostVisitPerDay(state, data) {
    state.mostVisitPerDay = data;
  },

  setMostVisitPerHour(state, data) {
    state.mostVisitPerHour = data;
  },

  setMostVisitPerCountry(state, data) {
    state.mostVisitPerCountry = data;
  },

  setVisitorsList(state, data) {
    state.visitorsList = data;
  },

  setServices(state, data) {
    state.services = data;
  },
  setService(state, data) {
    state.service = data;
  },

  setWaitingTickets(state, data) {
    state.waitingTickets = data;
  },
  setAnsweredTickets(state, data) {
    state.answeredTickets = data;
  },
  setClosedTickets(state, data) {
    state.closedTickets = data;
  },
  setTicket(state, data) {
    state.ticket = data;
  },
  setTicketCategories(state, data) {
    state.ticketCategories = data;
  },
  setBrands(state, data) {
    state.brands = data;
  },
  setBrand(state, data) {
    state.brand = data;
  },

  setFestivalDiscounts(state, data) {
    state.festivalDiscounts = data;
  },

  setProductCategoryChilds(state, data) {
    state.categoryChilds = data;
  },

  setProductFeatures(state, data) {
    state.productFeatures = data;
  },

  setProductFeaturesByCategory(state, data) {
    if (data && data.length > 0) {
      state.productFeaturesByCategory = data[0].featureCategories;
    } else {
      state.productFeaturesByCategory = data;
    }

  },

  setProductFeatureDetails(state, data) {
    state.productFeatureDetails = data.featureDetails;
  },

  setProductFeatureDetailsByFeatureId(state, data) {
    state.productFeatureDetails = data;
  },
  setProducts(state, data) {
    state.products = data;
  },

  setProduct(state, data) {
    state.product = data;
  },

  setProductImages(state, data) {
    state.productImages = data;
  },

  setOutOfStocks(state, data) {
    state.outOfStocks = data;
  },

  setNewReturns(state, data) {
    state.newReturns = data;
  },
  setCheckedReturns(state, data) {
    state.checkedReturns = data;
  },

  setFactor(state, data) {
    state.factor = data;
  },

  setContactMessages(state, data) {
    state.contactMessages = data;
  },
  setNewsLetters(state, data) {
    state.newsLetters = data;
  },

  setTeam(state, data) {
    state.team = data;
  },

  setFaqs(state, data) {
    state.faqs = data;
  },
  setFaq(state, data) {
    state.faq = data;
  },
};
